import { render, staticRenderFns } from "./inboxstreams.vue?vue&type=template&id=46a84c2d&scoped=true&"
import script from "./inboxstreams.vue?vue&type=script&lang=js&"
export * from "./inboxstreams.vue?vue&type=script&lang=js&"
import style0 from "./inboxstreams.vue?vue&type=style&index=0&id=46a84c2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a84c2d",
  null
  
)

export default component.exports